export default {
  fixed: 'fixed',
  flexible: 'flexible',
};
